export default "__VITE_ASSET__72178d2c__"